import React from 'react';
import styles from './index.module.scss';
import screens from '../../constants/screens';
import hasAuthorization from '../../auth/hasAuthorization'

// Components
import {faHome, faDollarSign, faMobileAlt, faCommentAlt, faBriefcase, faUserAlt, faHourglassHalf, faWrench} from '@fortawesome/free-solid-svg-icons';
import NavigationItem from './NavigationItem';

const SideTabNavigation = (props) => (
    <section className={styles.SideTabNavigation}>
        <NavigationItem 
            icon={faHome} 
            label="Dashboard"
            exact={true} />
        <NavigationItem 
            icon={faWrench} 
            label="Reparaciones"
            to={screens.repairs} />
        {/* <NavigationItem 
            icon={faHourglassHalf} 
            label="Tiempo"
            to={screens.clock} /> */}
        {/* {hasAuthorization('admin') && <NavigationItem 
            icon={faDollarSign} 
            label="Especiales"
            to={screens.specials} />}
        {hasAuthorization('admin') && <NavigationItem 
            icon={faMobileAlt} 
            label="Dispositivos"
            to={screens.devices} />}
        {hasAuthorization('power_user') && <NavigationItem 
            icon={faCommentAlt} 
            label="Mensajes"
            to={screens.messages} />}
        {hasAuthorization('power_user') && <NavigationItem 
            icon={faBriefcase} 
            label="Applicaciones"
            to={screens.applications} />} */}
        {hasAuthorization('power_user') && <NavigationItem 
            icon={faUserAlt} 
            label="Usuarios"
            to={screens.users} />}
    </section>
);

export default SideTabNavigation;